import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as actions from './actions';
import * as userActions from '../../actions/userAction';
import * as projectActions from '../../actions/projectAction';
import selectAllProps from './selectors';

import {Tabs, Tab} from 'material-ui/Tabs';
import {List, ListItem, Avatar, IconButton, AutoComplete, MenuItem} from 'material-ui';
import MyLoader from '../../components/MyLoader';
import EditProjectForm from '../../components/ProjectManager/EditProjectForm';
import ProjectStatsContainer from './ProjectStatsContainer'
import PeopleIcon from 'material-ui/svg-icons/social/person';
import DeleteIcon from 'material-ui/svg-icons/action/delete';
import {cyan400, red400} from 'material-ui/styles/colors';
import {removeDiacritics} from '../../utils/text';

const styles = {
    headline: {
        fontSize: 24,
        paddingTop: 16,
        marginBottom: 12,
        fontWeight: 400
    }
};

class ManageProjectContainer extends React.Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            searchText: ''
        };
    }

    componentWillMount() {
        this.props.actions.loadProject(this.props.params.projectId);
        this.props.userActions.getAllUsers();
        if (this.props.projectStates.length == 0) this.props.projectActions.getProjectStates();
    }

    handleUpdateInput(searchText) {
        this.setState({
            searchText: searchText
        });
    }

    onNewRequest(user) {
        if (!user.value) return false;
        this.props.actions.addProjectMember(this.props.project.id, user.value);
        this.setState({
            searchText: ''
        });
    }

    removeMember(user) {
        this.props.actions.removeProjectMember(this.props.project.id, user.id);
    }

    updateProject(data) {
        this.props.projectActions.updateProject(data).then((project) => {
            //this.context.router.push('/project/'+data.id);
        });
    }

    autoCompleteSearchFilter(searchText, key) {
        if (key.toLowerCase().indexOf(searchText.toLowerCase()) !== -1) return true;
        key = removeDiacritics(key);
        if (key.toLowerCase().indexOf(searchText.toLowerCase()) !== -1) return true;
    }

    render() {
        const onNewRequest = this.onNewRequest.bind(this);
        const removeMember = this.removeMember.bind(this);
        const updateProject = this.updateProject.bind(this);
        const handleUpdateInput = this.handleUpdateInput.bind(this);
        const autoCompleteSearchFilter = this.autoCompleteSearchFilter;
        if (this.props.loading || !this.props.project) return (<MyLoader/>);
        return (
            <div>
                <Tabs>
                    <Tab label="Général">
                        <EditProjectForm onSubmit={updateProject} projectStates={this.props.projectStates}/>
                    </Tab>
                    <Tab label="Membres">
                        <h3>{this.props.project.name}</h3>
                        <div>
                            <AutoComplete
                                hintText="Commencer à saisir le nom ou prénom d'un membre"
                                floatingLabelFixed
                                floatingLabelText="Ajouter un membre"
                                searchText={this.state.searchText}
                                fullWidth
                                onUpdateInput={handleUpdateInput}
                                onNewRequest={onNewRequest}
                                dataSource={this.props.users}
                                filter={autoCompleteSearchFilter}
                            />
                            <List>
                                {this.props.project.members.map((member) => (
                                    <ListItem key={member.id} disabled
                                              primaryText={member.firstname + ' ' + member.lastname}
                                              leftAvatar={<Avatar backgroundColor={cyan400} icon={<PeopleIcon/>}/>}
                                              rightIconButton={<div style={{marginTop: 5}}>
                                                  <IconButton onClick={() => removeMember(member)} style={{
                                                      padding: 0,
                                                      marginRight: 5,
                                                      width: 30,
                                                      height: 30
                                                  }} iconStyle={{width: 30, height: 30}}>
                                                      <DeleteIcon color={red400}/>
                                                  </IconButton>
                                              </div>}
                                    />
                                ))}
                            </List>
                        </div>
                    </Tab>
                    <Tab label="Statistiques">
                        <h3>{this.props.project.name}</h3>
                        <ProjectStatsContainer/>
                    </Tab>
                    {/*<Tab label="Etapes" data-route="/home">
                    <div>
                        <h2 style={styles.headline}>Etapes</h2>
                        <p>
                            This is a third example tab.
                        </p>
                    </div>
                </Tab>*/}
                </Tabs>
            </div>
        );
    }
}

ManageProjectContainer.propTypes = {
    users: PropTypes.array,
    projectStates: PropTypes.array,
    project: PropTypes.object,
    params: PropTypes.object,
    actions: PropTypes.object,
    userActions: PropTypes.object,
    projectActions: PropTypes.object,
    loading: PropTypes.bool
};

ManageProjectContainer.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    return selectAllProps(state);
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(actions, dispatch),
        userActions: bindActionCreators(userActions, dispatch),
        projectActions: bindActionCreators(projectActions, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ManageProjectContainer);


/** WEBPACK FOOTER **
 ** ./src/container/ProjectContainer/ManageProjectContainer.js
 **/